import * as React from 'react';
export const IcRain = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.91 11.15A4.001 4.001 0 0016 8c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 13c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85zm-8.38-3.13c.88-.99 2.07-1.66 3.36-1.91C14.48 4.33 12.9 3 11 3c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 004 8c-1.1 0-2 .9-2 2s.9 2 2 2h2.36c.27-.24.58-.44.9-.6a5.028 5.028 0 014.27-3.38zM9.2 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2z'
      fill='currentColor'
    />
  </svg>
);
